import { useContext } from "react";
import { categoryContextType } from "../../utils/typeDefs";
import { Tree, Loader } from "rsuite";
import { Plus, Minus } from "@rsuite/icons";
import CategoryNode from "../../Components/category/categoryNode.component";
import { CategoryContext } from "../../core/context/categoryContextProvider";

type categoryProps = {
  title: string;
};

type iconProps = {
  size: string;
};

const Category = ({ title }: categoryProps) => {
  const { categoryData } = useContext(CategoryContext) as categoryContextType;

  const iconSize = "0.8em";
  const PlusIcon = ({ size }: iconProps) => <Plus style={{ fontSize: size }} />;
  const MinusIcon = ({ size }: iconProps) => (
    <Minus style={{ fontSize: size }} />
  );

  return (
    <section>
      <div className="d-flex justify-content-between">
        <h1 className="page-title pb-3">{title}</h1>
      </div>

      <div>
        {!categoryData.length && (
          <Loader size="lg" center content="loading..." vertical />
        )}
        <Tree
          virtualized
          data={categoryData}
          labelKey="title"
          valueKey="id"
          childrenKey="childs"
          defaultExpandItemValues={[null]}
          showIndentLine
          renderTreeIcon={(item) =>
            item.childs.length === 0 ? (
              <span></span>
            ) : item.expand ? (
              <MinusIcon size={iconSize} />
            ) : (
              <PlusIcon size={iconSize} />
            )
          }
          renderTreeNode={(categoryData: any) => {
            return <CategoryNode categoryData={categoryData} />;
          }}
        />
      </div>
    </section>
  );
};

export default Category;
